// extracted by mini-css-extract-plugin
export default {"divider":"AdditionalElements-divider___6sEYy","header":"AdditionalElements-header___gxsTT"};